<style>
.ivu-table-row {
    color : #000000;
}

.ivu-table .demo-table-settled-row td {
    color: #19be6b;
}

.ivu-table .demo-table-disc-row td {
    color: #c30e0e;
}

.ivu-table .demo-table-claim-row td {
    color: #2db7f5;
}

.ivu-table .demo-table-claim-depo-row td {
    color: #c32df5;
}

.ivu-table .demo-table-giro-row td {
    color: #de2df5;
}

.ivu-table .demo-table-dfm-row td {
    color: #0800ff;
}

.ivu-collapse-content {
  overflow: hidden;
}
</style>

<template>
    <div>

        <Card>
            <p slot="title">
                Kartu Piutang
            </p>
            <Row type="flex" justify="space-between" class="code-row-bg">
              <Col span="7">
                <Select style="width: 100%;"
                        placeholder="Ketik Marking"
                        v-model="markingIdSelected"
                        filterable
                        clearable
                        remote
                        :remote-method="getMarkingByCode"
                        :loading="loadingGetMarking"
                        @on-change="setMarkingCode()">
                  <Option v-for="option in optionMarkings"
                          :value="option.value"
                          :key="option.value">
                    {{ option.label }}
                  </Option>
                </Select>
              </Col>

              <Col span="2" style="display:flex;align-items:center;">
                <div v-if="topColor"
                    :style="{
                      width: '25px',
                      height: '25px',
                      borderRadius: '50%',
                      backgroundColor: topColor,
                      border: '1px solid #ccc'
                    }">
                </div>
              </Col>

              <Col span="6">
                <Spin size="large" v-show="loadingGetReceivable"></Spin>
              </Col>

              <Col span="7"></Col>
            </Row>
            <br />
            <Collapse
                v-if="historyDeleteClaim.length > 0 && markingIdSelected"
                v-model="activeCollapseNames"
                @on-change="onCollapseChange">
                <Panel name="1">
                    History Hapus Klaim
                    <Table slot="content"
                        v-if="historyDeleteClaim.length > 0"
                        :columns="tableHistoryColumns"
                        :data="historyDeleteClaim"
                    ></Table>
                </Panel>
            </Collapse>

            <br />
            <Card v-show="(receivables.length > 0 || isSupervisor()) && markingIdSelected">
                <p slot="title"></p>
                <template slot="extra">
                    <Button v-show="canCreateReceivable()" type="success" @click="modal.createReceivable = true"
                        icon="plus-round" size="small">
                        Tambah Piutang
                    </Button>

                    <!-- <Button v-show="canCreateReceivableDeposit()"
                        type="warning"
                        @click="modal.createReceivableDeposit=true"
                        icon="plus-round"
                        size="small"  >
                            Tambah Deposit
                    </Button> -->

                    <Button v-show="isShowRateAdjustment" type="warning" @click="modal.createRateAdjustment = true"
                        icon="ios-gear" size="small">
                        Penyesuaian Rate
                    </Button>
                </template>

                <div v-show="topColor">
                  <Alert :type="alertType" show-icon :class="alertClass">
                    Term Of Payment
                  </Alert>
                </div>

                <div v-show="depositRemaining > 0">
                    <Alert type="warning" show-icon>Deposit = {{ depositRemaining | currency }}</Alert>
                    <Alert show-icon>Balance - Deposit = {{ (countBalance - depositRemaining ) | currency }}</Alert>
                </div>

                <div v-show="depositMutasiRemaining > 0">
                    <Alert type="warning" show-icon>Deposit Mutasi = {{ depositMutasiRemaining | currency }}</Alert>
                    <!-- <Alert show-icon>Balance - Deposit Mutasi = {{ (countBalance - depositMutasiRemaining) | currency }}</Alert> -->
                </div>

                <Table
                    :row-class-name="rowClassName"
                    :columns="tableColumns"
                    :data="receivables"
                    no-data-text=""
                    @on-row-click="handleRowClick"
                />


                <Modal
                  v-model="showModal"
                  title="Edit Currency Rate"
                  width="600"
                  :mask-closable="false"
                >
                  <Form
                    ref="rateForm"
                    :model="formRate"
                    label-position="left"
                    :label-width="140"
                  >
                    <FormItem label="Description" prop="description">
                        <p v-html="formRate.realDescription"></p>
                    </FormItem>

                    <FormItem label="Debit" prop="debit">
                        <Input v-model="formRate.debit" disabled></Input>
                    </FormItem>

                    <FormItem label="Credit" prop="credit">
                        <Input v-model="formRate.credit" disabled></Input>
                    </FormItem>

                    <FormItem label="Rate" prop="rate">
                      <money v-model="formRate.rate" v-bind="moneyFloat" class="ivu-input right"
                        style="width: 100%;"></money>
                    </FormItem>

                    <FormItem label="Receivable Date" prop="receivable_date">
                        <Input v-model="formRate.receivable_date" style="width: 100%" disabled readonly />
                    </FormItem>

                    <FormItem v-show="user.role === 'ADMINISTRATOR'" label="Settle Date" prop="settle_date">
                        <Date-picker v-model="formRate.settle_date"></Date-picker>
                    </FormItem>

                    <FormItem v-show="user.role === 'ADMINISTRATOR'" label="Payment Sum" prop="payment_sum">
                        <Input v-model="formRate.payment_sum"></Input>
                    </FormItem>

                    <FormItem v-show="user.role === 'ADMINISTRATOR'">
                      <Button
                        type="error"
                        icon="ios-trash"
                        :disabled="user.role !== 'ADMINISTRATOR'"
                        @click="confirmDelete(formRate.receivable_id)"
                      >
                        Delete
                      </Button>
                    </FormItem>
                  </Form>

                  <div slot="footer">
                    <Button @click="showModal = false">Cancel</Button>
                    <Button type="primary" @click="submitRate">Save</Button>
                  </div>
                </Modal>

                <Modal
                  v-model="showModalDesc"
                  title="Edit Description"
                  width="70%"
                  :mask-closable="false"
                >
                  <Form
                    ref="rateForm"
                    :model="formRate"
                    label-position="left"
                    :label-width="140"
                  >
                    <FormItem label="Receivable Date" prop="receivable_date">
                        <Input v-model="formRate.receivable_date" style="width: 100%" disabled readonly />
                    </FormItem>
                    <FormItem label="Description" prop="description">
                        <Input v-model="formRate.realDescription"></Input>
                    </FormItem>
                    <FormItem label="Debit" prop="debit">
                        <Input v-model="formRate.debit" disabled></Input>
                    </FormItem>
                    <FormItem label="Credit" prop="credit">
                        <Input v-model="formRate.credit" disabled></Input>
                    </FormItem>
                    <FormItem v-show="user.role === 'ADMINISTRATOR'" label="Settle Date" prop="settle_date">
                        <Date-picker v-model="formRate.settle_date"></Date-picker>
                    </FormItem>
                    <FormItem v-show="user.role === 'ADMINISTRATOR'" label="Payment Sum" prop="payment_sum">
                        <Input v-model="formRate.payment_sum"></Input>
                    </FormItem>
                  </Form>

                  <Table
                    size="small"
                    :columns="paymentDetail"
                    :data="paymentData"
                    style="margin-top: 16px"
                  >
                  </Table>

                  <br />
                  <span style="font-size: 14px; font-weight: bold">History:</span>
                  <Table
                    size="small"
                    :columns="columnsPreview"
                    :data="historyData"
                    style="margin-top: 16px"
                  >
                  </Table>


                  <div slot="footer">
                    <Button @click="showModalDesc = false">Cancel</Button>
                    <Button type="primary" @click="submitEditReceivable">Save</Button>
                  </div>
                </Modal>


            </Card>
        </Card>

        <Modal v-model="modal.createReceivable" width="500px" @on-cancel="clearCreateReceivable()">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tambah Piutang</span>
            </p>

            <Form ref="createReceivableForm" :model="createReceivable" :rules="createReceivableRule" :label-width="120">
                <Form-item label="Tgl Transaksi" prop="transactionDate">
                    <Date-picker v-model="createReceivable.transactionDate" type="date" placeholder="Pilih Tanggal"
                        format="yyyy-MM-dd"></Date-picker>
                </Form-item>
                <Form-item label="Keterangan" prop="description" v-show="true">
                    <Input v-model="createReceivable.description" style="width: 300px;"></Input>
                </Form-item>
                <Form-item label="Jumlah" v-show="true">
                    <money v-model="createReceivable.amount" prop="amount" v-bind="isShowRateAdjustment ? moneyFloat : money" class="ivu-input right"
                        style="width: 150px;"></money>
                </Form-item>
                <Form-item label="Upload File" prop="filename">
                    <br>
                    <img v-show="createReceivable.imageUploaded" :src="createReceivable.imageUploaded"
                        alt="Uploaded Image" style="width: 100%; height: auto;" />
                    <Upload type="drag" ref="upload" name="fileUploaded" :action="this.serverUrlUploadFile"
                        :before-upload="handleBeforeUpload" accept="image/*">
                        <div style="padding: 20px 0">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>Click or drag files here to upload</p>
                        </div>
                    </Upload>
                    <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
                </Form-item>
            </Form>

            <div slot="footer">
                <Button v-show="true" type="primary" :loading="loadingCreateReceivable"
                    @click="validateAndCreateReceivable">
                    <span v-if="!loadingCreateReceivable">Simpan</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>

        <Modal v-model="modal.createReceivableDeposit" width="500px" @on-cancel="clearCreateReceivableDeposit()">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tambah Deposit</span>
            </p>

            <Form :label-width="120">
                <Form-item label="Tgl Transaksi">
                    <Row>
                        <Col span="4">
                        <Date-picker v-model="createReceivableDeposit.transactionDate" style="width: 110px;" type="date"
                            placeholder="" format="dd/MM/yyyy">
                        </Date-picker>

                        </Col>
                        <Col span="1">&nbsp;
                        </Col>
                    </Row>
                </Form-item>
                <Form-item label="Keterangan" v-show="true">
                    <Input v-model="createReceivableDeposit.description" style="width: 300px;"></Input>
                </Form-item>
                <Form-item label="Jumlah" v-show="true">
                    <money v-model="createReceivableDeposit.amount" v-bind="money" class="ivu-input right"
                        style="width: 150px;"></money>
                </Form-item>
                <!-- <Form-item label="Upload File" prop="file">
                        <br>
                        <Upload
                            type="drag"
                            ref="upload"
                            name="fileUploaded"
                            :action="this.serverUrlUploadFile"
                            :before-upload="handleBeforeUpload">
                            <div style="padding: 20px 0">
                                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                                <p>Click or drag files here to upload</p>
                            </div>
                        </Upload>
                        <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
                    </Form-item> -->
            </Form>

            <div slot="footer">
                <Button v-show="true" type="primary" :loading="loadingCreateReceivableDeposit"
                    @click="postCreateReceivableDeposit">
                    <span v-if="!loadingCreateReceivableDeposit">Simpan</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>

        <Modal v-model="modal.createPayment" width="80%">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Payment set</span>
            </p>

            <Form :label-width="120">

                <Form-item label="Tgl Pembayaran">
                    <Row>
                        <Col span="5">
                        <Date-picker v-model="createPaymentPending.paymentDate" style="width: 250px;" type="date"
                            format="yyyy-MM-dd" @on-change="checkButtonSave">
                        </Date-picker>
                        </Col>
                    </Row>
                </Form-item>

                <Form-item label="Marking">
                    <Input v-model="createPaymentPending.selectedMarkingLabel" disabled style="width: 250px;"
                        placeholder="Marking"></Input>
                </Form-item>

                <Form-item label="Keterangan">
                    <Input v-model="createPaymentPending.description" style="width: 250px;"
                        @on-change="checkButtonSave"></Input>
                </Form-item>

                <Form-item label="Deposito Mutasi">
                    <Alert style="width: 250px;" type="warning" show-icon>{{
                        createPaymentPending.mutasiRemainingPayment | currency }}
                    </Alert>
                    <font style="color: red;"
                        v-if="createPaymentPending.totalUseDepositAmount > 0 && createPaymentPending.totalUseDepositAmount > createPaymentPending.mutasiRemainingPayment">
                        Terpakai
                        {{ createPaymentPending.totalUseDepositAmount | currency }} - LEBIH</font>

                    <font style="color: green;"
                        v-if="createPaymentPending.totalUseDepositAmount > 0 && createPaymentPending.totalUseDepositAmount <= createPaymentPending.depositRemainingPayment">
                        Terpakai: {{ createPaymentPending.totalUseDepositAmount | currency }}, Sisa: {{
                            (createPaymentPending.depositRemainingPayment -
                                createPaymentPending.totalUseDepositAmount) | currency }}
                    </font>
                </Form-item>

                <Form-item label="Uang Diterima">
                    <money v-model="createPaymentPending.amountReceived" v-bind="money" class="ivu-input right"
                        style="width: 250px;" disabled>
                    </money>

                    <font v-show="createPaymentPending.amountResidue != 0" style="margin-left: 20px;">
                        Selisih &nbsp; {{ createPaymentPending.amountResidue | currency }}
                    </font>
                </Form-item>

            </Form>

            <Card v-show="this.invoiceDues.length > 0">
                <p slot="title">
                    Daftar Invoice
                </p>

                <Row type="flex" class="code-row-bg ivu-row-flex-space-between">
                    <template>
                        <Col span="2">
                        Tgl Bongkar
                        </Col>
                        <Col span="8">
                        Keterangan
                        </Col>
                        <Col span="2">
                        Total
                        </Col>
                        <Col span="1">
                        </Col>
                        <Col span="2">
                        Sisa
                        </Col>
                        <Col span="1">
                        </Col>
                        <Col span="5">
                        Alokasi Pembayaran
                        </Col>
                        <Col span="1">
                        </Col>
                    </template>
                </Row>
                <br />
                <hr />
                <br />
                <div v-for="invoiceDue in invoiceDues">
                    <cInvoicePaymentMutasi :invoiceDue="invoiceDue"
                        :depositRemaining="createPaymentPending.depositRemainingPayment"
                        :paymentPendingId="createPaymentPending.paymentPendingId"
                        :paymentPendingAmount="createPaymentPending.paymentPendingAmount"
                        @setAllocateAmount="setAllocateAmount">
                    </cInvoicePaymentMutasi>
                    <br />
                </div>
            </Card>

            <div slot="footer">
                <Button v-show="isButtonSave" type="primary" :loading="loadingCreateReceivable" @click="postPayment">
                    <span v-if="!loadingCreateReceivable">Simpan</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>

        <Modal v-model="modal.createRateAdjustment" width="500px" @on-cancel="clearCreateRateAdjustment()">
            <p slot="header" style="color:#f90;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Penyesuaian Rate</span>
            </p>

            <Form :label-width="120">
                <Form-item label="Tgl Transaksi">
                    <Date-picker v-model="createRateAdjustment.transactionDate" style="width: 110px;" type="date"
                        placeholder="" format="dd/MM/yyyy">
                    </Date-picker>
                </Form-item>
                <Form-item label="Pembayaran" v-show="true">
                    <!-- <Input v-model="createRateAdjustment.containers" style="width: 300px;"></Input> -->
                    <Select v-model="createRateAdjustment.containerSelected" placeholder="Select" clearable filterable>
                        <Option v-for="container in createRateAdjustment.containers" :value="container.receivableId"
                            :key="container.receivableId">{{ container.labelContainer }}</Option>
                    </Select>
                </Form-item>
                <Form-item label="Jumlah" v-show="true">
                    <money v-model="createRateAdjustment.amount" v-bind="moneyFloat" class="ivu-input right"
                        style="width: 150px;"></money>
                </Form-item>
            </Form>

            <div slot="footer">
                <Button v-show="true" type="primary" :loading="loadingCreateRateAdjustment"
                    @click="postCreateRateAdjustment">
                    <span v-if="!loadingCreateRateAdjustment">Simpan</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>

    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import cInvoicePaymentMutasi from '@/components/receivable/cInvoicePaymentMutasi'
import _ from 'lodash'
import moment from 'moment'
import { rule } from 'postcss';
import { Money } from 'v-money'

var axios = require('axios');
const numeral = require('numeral');



export default {
    components: { cInvoicePaymentMutasi, Money },
    data() {
        return {
            showModal: false,
            showModalDesc: false,
            selectedRow: {},
            user: {
                username: '',
                role: ''
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            },
            moneyFloat: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            isShowRateAdjustment: false,
            modal: {
                createReceivable: false,
                createReceivableDeposit: false,
                createRateAdjustment: false,
                createPayment: false
            },
            createReceivable: {
                transactionDate: '',
                description: '',
                amount: 0,
                filename: '',
                imageUploaded: '',
            },
            createReceivableDeposit: {
                transactionDate: '',
                description: '',
                amount: 0,
                filename: ''
            },
            createRateAdjustment: {
                receivableId: '',
                transactionDate: '',
                containers: [],
                containerSelected: '',
                amount: 0
            },
            createPaymentPending: {
                paymentDate: '',
                mutasiRemainingPayment: 0, // mutasi deposit sebelumnya
                depositRemainingPayment: 0,
                amountReceived: '',
                amountResidue: '',
                description: '',
                paymentPendingAmount: 0,
                totalUseDepositAmount: 0,
                paymentPendingId: null,
                category: '',
                selectedMarkingLabel: '',
                creditRound: 0,
                receivableId: '',
                depositType: '',
                accountNumber: '',
                discountReceived: '',
            },
            totalMutasiRemaining: 0, // untuk total deposit di modal payment set
            loadingCreateReceivable: false,
            loadingCreateReceivableDeposit: false,
            loadingCreateRateAdjustment: false,
            markingIdSelected: '',
            markingLabelSelected: '',
            topColor: null,
            depositRemaining: Number, // untuk menampung total sisa deposit
            depositMutasiRemaining: Number, // untuk menampung total sisa deposit
            countBalance: Number,
            optionMarkings: [],
            loadingGetMarking: false,
            loadingGetReceivable: false,
            markings: [],
            receivables: [],
            historyDeleteClaim: [],
            activeCollapseNames: [],
            subbranchcode: localStorage.getItem('user.subbranchcode'),
            selectedTopColor: null,
            paymentData: [],
            historyData: [],
            paymentDetail: [
              {
                title: 'Description',
                key: 'description',
                align: 'center'
              },
              {
                title: 'Amount',
                key: 'amount',
                align: 'center'
              },
              {
                title: 'Payment Settlement',
                width: 200,
                align: 'center',
                render: (h, { row }) => {
                  if(row.checked == 1) {
                    row.checked = true
                  } else {
                    row.checked = false
                  }

                  return h('Checkbox', {

                    props: {
                      value: row.checked
                    },
                    on: {
                      'on-change': () => {
                        this.confirmAction(row)
                      }
                    }
                  })
                }
              }
            ],
            columnsPreview: [
              {
                title: 'Edit Date',
                key: 'logdate',
                align: 'center',
                width: 150
              },
              {
                title: 'Edit By',
                key: 'userid',
                width: 120
              },
              {
                title: 'New Description',
                key: 'new_description',
                align: 'left'
              },
              {
                title: 'Old Description',
                key: 'old_description',
                align: 'left'
              }
            ],
            tableColumns: [
                {
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: 'Tgl',
                    key: 'transactionDate',
                    type: 'html',
                    sortable: false
                },
                {
                    title: 'Keterangan',
                    key: 'description',
                    width: 300,
                    type: 'html',
                    sortable: false
                },
                {
                    title: 'Debet',
                    key: 'debitAmount',
                    align: 'right',
                    sortable: false,
                    cellClassName: {
                        name: 'demo-table-info-cell-name'
                    }

                },
                {
                    title: 'Kredit',
                    key: 'creditAmount',
                    align: 'right',
                    sortable: false,
                    render: (h, params) => {
                        return h('span', {
                            props: {},
                            style: {}
                        }, params.row.creditAmount);

                    }
                },
                {
                    title: 'Balance',
                    key: 'balance',
                    align: 'right',
                    sortable: false
                }
            ],
            tableHistoryColumns: [
              { type: 'index', width: 60, align: 'center' },
              { title: 'Tgl. Pembayaran', key: 'paymentDate', minWidth: 75, sortable: false },
              { title: 'Marking', key: 'markingheadercode', minWidth: 75, sortable: true },
              { title: 'Nota Transaksi', key: 'transactionNote', minWidth: 100, sortable: true },
              { title: 'Jumlah', align: 'right', minWidth: 50, key: 'amount', sortable: false },
              { title: 'Detail', type: 'html', align: 'left',  minWidth: 300, key: 'description', sortable: false }, // <-- tanpa width, ini akan mengisi sisa
              { title: 'Tgl. Hapus', key: 'deleteAt', minWidth: 80, sortable: false },
              { title: 'Dihapus oleh', key: 'deletedBy', minWidth: 80, sortable: false },
        ],
            filterInput: '',
            createReceivableRule: {
                transactionDate: [
                    { required: true, type: 'date', message: 'Tanggal transaksi wajib diisi', trigger: 'change' }
                ],
                description: [
                    { required: true, message: 'Keterangan wajib diisi', trigger: 'blur' },
                ],
                amount: [
                    { required: true, message: 'Jumlah wajib diisi', trigger: 'blur' },
                    { type: 'number', min: 0.01, message: 'Jumlah harus lebih besar dari 0', trigger: 'change', transform: (value) => Number(value) }
                ],
                filename: [
                    { required: true, message: 'File wajib diunggah', trigger: 'change' },
                    { validator: this.validateFileUpload, trigger: 'change' }
                ],
            },
            serverUrlUploadFile: '',
            isProgress: false,
            pValue: 0,
            invoiceDues: [],
            loadingGetPayment: false,
            isButtonSave: false,
            formRate: {
              receivable_id: null,
              description: null,
              rate: null,
              receivable_date: '',
            }
        }
    },
    methods: {
        onCollapseChange(activeNames) {
          this.$nextTick(() => {
            // ref ke Table
            if (this.$refs.historyTable) {
              this.$refs.historyTable.handleResize()
            }
          })
        },
        handleRowClick(row) {
            if (
                this.markingLabelSelected.includes('SBR/') ||
                this.markingLabelSelected.includes('SBRT') ||
                this.markingLabelSelected.includes('CTH')
            ) {
                this.onRowClick(row)
            } else if (this.canEditReceivable()) {
                this.onRowClickEditDesc(row)
                return
            }
        },
        onRowClick(row, index) {
          this.formRate.receivable_id = null;
          this.formRate.description = null;
          this.formRate.realDescription = null;
          this.formRate.rate = 0;
          this.formRate.receivable_date = null;
          this.formRate.invoiceid = null;
          this.formRate.payment_sum = null;
          this.formRate.settle_date = null;

          if(row.invoice_due) {
            this.formRate.payment_sum = numeral(row.invoice_due.paymentSum).format('0,00');
            this.formRate.settle_date = row.invoice_due.settledDate;
          }

          this.formRate.receivable_id = row.receivableId;
          this.formRate.description = row.description;
          this.formRate.realDescription = row.realDescription;
          this.formRate.rate = row.currency_rate ? row.currency_rate : 0;
          this.formRate.debit = row.debitAmount;
          this.formRate.credit = row.creditAmount;
          this.formRate.receivable_date = row.valueTransactionDate;

          this.showModal = true
        },
        onRowClickEditDesc(row, index) {
          this.$Loading.start();

          this.formRate.receivable_id = null;
          this.formRate.description = null;
          this.formRate.realDescription = null;
          this.formRate.rate = 0;
          this.formRate.receivable_date = null;
          this.formRate.invoiceid = null;
          this.formRate.payment_sum = null;
          this.formRate.settle_date = null;

          this.paymentData = [];
          this.formRate.invoiceid = row.invoiceid;

          if(this.formRate.invoiceid && this.user.role !== 'ADMINISTRATOR') {
            this.$Message.info('Hanya bisa edit keterangan pembayaran.');
            this.$Loading.finish();
          } else {
            this.formRate.receivable_id = row.receivableId;
            this.formRate.description = row.description;
            this.formRate.realDescription = row.realDescription;
            this.formRate.rate = row.currency_rate ? row.currency_rate : 0;
            this.formRate.debit = row.debitAmount;
            this.formRate.credit = row.creditAmount;
            this.formRate.receivable_date = row.valueTransactionDate;

            if(row.invoice_due) {
              this.formRate.payment_sum = numeral(row.invoice_due.paymentSum).format('0,0');
              this.formRate.settle_date = row.invoice_due.settledDate;
            }

            if(this.formRate.invoiceid == null) {
              _.forEach(row.payment.payment_allocate, (allocate) => {
                this.paymentData.push({
                  id: allocate.id,
                  amount: numeral(allocate.allocateAmount).format('0,0'),
                  description: allocate.invoice_due.receivable.description,
                  checked: allocate.is_settlement,
                })
              })
            }

            this.$Loading.finish();
            this.getHistoryEditDescription(row);
          }
        },
        confirmAction(row) {


          this.$Modal.confirm({
            title: 'Confirmation',
            width: '25%',
            content: 'Are you sure you want to set this as a <b> Payment Settlement </b>?',
            onOk: () => {
              if(row.checked == false) {
                this.$set(row, 'checked', true)
              } else {
                this.$set(row, 'checked', false)
              }
              this.setSettlementStatusToPaymentAllocate(row);
            },
            onCancel: () => {
              if(row.checked == false) {
                this.$set(row, 'checked', false)
              } else {
                this.$set(row, 'checked', true)
              }
            }
          })
        },

        doSomething(row) {
          console.log('Confirmed:', row.id)
        },
        clearCreateReceivable() {
            this.$refs.createReceivableForm.resetFields();
            this.createReceivable.transactionDate = ''
            this.createReceivable.description = ''
            this.createReceivable.amount = 0
            this.createReceivable.filename = ''
        },
        clearCreateReceivableDeposit() {
            this.createReceivableDeposit.transactionDate = ''
            this.createReceivableDeposit.description = ''
            this.createReceivableDeposit.amount = 0
            this.createReceivableDeposit.filename = ''
        },
        clearCreateRateAdjustment() {
            this.createRateAdjustment.receivableId = ''
            this.createRateAdjustment.transactionDate = ''
            this.createRateAdjustment.containerSelected = ''
            this.createRateAdjustment.amount = 0
            this.loadingCreateRateAdjustment = false
        },
        canCreateReceivable() {
            let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'SUPERVISOR-SBY'], this.user.role);

            return canAccess;
        },
        canEditReceivable() {
            let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN-SUPER', 'SUPERVISOR-SBY'], this.user.role);

            return canAccess;
        },
        isSupervisor() {
            let isSupervisor = ["WILYA-FA", "SURYANTI", "SUSAN", "INDRA", "SURINDA", "LINDA", "ADRI", "ERIC", "SYSTEM"].includes(this.user.username);

            return isSupervisor;
        },
        canCreateReceivableDeposit() {
            let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'SUPERVISOR-SBY'], this.user.role);

            return canAccess;
        },
        canCreateRateAdjustment() {
            return true;
        },
        validateFileUpload(rule, value, callback) {
            if (!value) {
                callback(new Error('File gambar wajib diunggah'));
            } else if (!this.createReceivable.imageUploaded) {
                callback(new Error('Gagal mengunggah gambar. Silakan coba lagi.'));
            } else {
                callback();
            }
        },
        handleBeforeUpload(file) {
            const isImage = file.type.startsWith('image/');

            if (!isImage) {
                this.$Message.error('Anda hanya dapat mengunggah file gambar!');
                return false;
            }

            const formData = new FormData();
            formData.append('file', file);
            formData.append('marking', this.markingLabelSelected);

            this.isProgress = true;
            this.pValue = Math.floor(Math.random() * 100);

            HTTP.post('receivable/file/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then(response => {
                    this.createReceivable.filename = response.data.filename;
                    this.createReceivable.imageUploaded = response.data.url;
                    this.pValue = 100;
                    this.$refs.createReceivableForm.validateField('filename');
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
                .finally(() => {
                    this.isProgress = false;
                });

            return false;
        },
        validateAndCreateReceivable() {

            this.$refs.createReceivableForm.validate((valid) => {
                if (valid) {
                    if (!this.createReceivable.filename || !this.createReceivable.imageUploaded) {
                        this.$Message.error('File gambar wajib diunggah');
                        return;
                    }
                    this.postCreateReceivable();
                } else {

                    this.$Message.error('Harap isi semua field yang diperlukan dengan benar');
                }
            });
        },
        postCreateReceivable() {
            this.loadingCreateReceivable = true
            this.createReceivable.transactionDate = moment(this.createReceivable.transactionDate, 'YYYY-MM-DD').format("YYYY-MM-DD");

            let payload = {
                markingHeaderId: this.markingIdSelected,
                transactionDate: this.createReceivable.transactionDate,
                description: this.createReceivable.description,
                amount: this.createReceivable.amount,
                filename: this.createReceivable.filename,
            }


            HTTP
                .post('receivable/debit/create', payload)
                .then(response => {
                    this.clearCreateReceivable()

                    this.loadingCreateReceivable = false
                    this.modal.createReceivable = false
                    this.getReceivableData()
                })
                .catch(e => {
                    this.clearCreateReceivable()
                    this.loadingCreateReceivable = false
                    this.modal.createReceivable = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        postCreateReceivableDeposit() {
            this.loadingCreateReceivableDeposit = true
            this.createReceivableDeposit.transactionDate = moment(this.createReceivableDeposit.transactionDate, 'YYYY-MM-DD').format("YYYY-MM-DD");

            let payload = {
                markingHeaderId: this.markingIdSelected,
                transactionDate: this.createReceivableDeposit.transactionDate,
                description: "Tambah Deposit - " + this.createReceivableDeposit.description,
                amount: this.createReceivableDeposit.amount,
                filename: this.createReceivableDeposit.filename,
            }

            HTTP
                .post('receivable/deposit/create', payload)
                .then(response => {
                    this.clearCreateReceivableDeposit()

                    this.loadingCreateReceivableDeposit = false
                    this.modal.createReceivableDeposit = false
                    this.getReceivableData()
                })
                .catch(e => {
                    this.clearCreateReceivableDeposit()
                    this.loadingCreateReceivableDeposit = false
                    this.modal.createReceivableDeposit = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        rowClassName(row, index) {

            if (row.isSettled) {
                return 'demo-table-settled-row';
            }

            if (row.category == 'disc') {
                return 'demo-table-disc-row';
            }

            if (row.claimId) {
                return 'demo-table-claim-depo-row';
            }

            if (row.claim) {
                return 'demo-table-claim-row';
            }

            if (row.giroId) {
                return 'demo-table-giro-row';
            }

            if (row.type == 'DFM') {
                return 'demo-table-dfm-row';
            }

            return '';
        },
        getReceivable: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('receivable/cut-off/' + this.markingIdSelected)
            } else {
                this.receivables = []
            }
        },
        getDepositRemaining: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('deposit/remaining/' + this.markingIdSelected)
            } else {
                this.depositRemaining = 0;
            }
        },
        getDepositMutasiRemaining: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('deposit/mutasi/' + this.markingIdSelected)
            } else {
                this.depositMutasiRemaining = 0;
            }
        },
        getBalanceCutOff: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('receivable/balance/cut-off/' + this.markingIdSelected)
            } else {
                this.depositRemaining = 0;
            }
        },
        getReceivableData: function () {
            let parent = this;

            this.invoiceDues = []
            this.receivables = []
            this.amountResidue = ''
            this.amountReceived = ''
            this.description = ''
            this.depositRemaining = Number
            this.depositMutasiRemaining = Number
            this.countBalance = Number
            this.totalMutasiRemaining = 0
            this.createRateAdjustment.containers = []

            if (this.markingIdSelected == '') {
                return;
            }

            this.loadingGetReceivable = true;
            axios.all([
                this.getReceivable(),
                this.getDepositRemaining(),
                this.getDepositMutasiRemaining(),
                this.getBalanceCutOff()
            ]).then(axios.spread((receivableRes, depositRemainingRes, depositMutasiRes, balanceCutOff) => {
                let receivables = []
                let countBalance = 0;

                parent.balanceCutOff = balanceCutOff.data.balance

                if (parent.balanceCutOff != 0) {
                    let createdby = "<br/><i> SYSTEM </i>"

                    let receivable = {
                        receivableId: '',
                        transactionDate: parent.showDateFormatted('2025-01-01') + createdby,
                        valueTransactionDate: parent.showDateFormatted('2025-01-01'),
                        markingHeaderId: '',
                        invoicefee: numeral(0).format('0,0'),
                        isSettled: false,
                        markingheadercode: '',
                        description: 'Saldo Terakhir',
                        debitAmount: numeral(0).format('0,0'),
                        creditAmount: numeral(0).format('0,0'),
                        balance: numeral(parent.balanceCutOff).format('0,0'),
                        category: null,
                        type: null,
                        claimId: null,
                        claim: null,
                        giro: null,
                        payment: null,
                        paymentPendingId: null
                    }

                    countBalance = parent.balanceCutOff
                    receivables.push(receivable)
                }
                // console.info(receivableRes.data)
                _.forEach(receivableRes.data, function (value) {
                    let invoicefee = value.invoice != null ? value.invoice.invoicefee : 0;
                    let creditAmount = value.creditAmount
                    let debitAmount = value.debitAmount;
                    let paymentSum = value.payment_sum;

                    console.info("Credit :"+creditAmount)

                    let totalvolume = value.invoice != null ? value.invoice.totalvolume : 0;
                    let isSettled = parent.isSettled(value.invoice_due)

                    let description = value.description
                    let realDescription = value.description
                    if (value.invoice != null) {
                        description += "<br/>( vol = " + numeral(totalvolume).format('0.000');

                        if (invoicefee != debitAmount) {
                            description += ", inv = " + numeral(invoicefee).format('0,0')
                        }
                        description += " )"
                    }

                    //Faisal 12 Januari : Deposit dari Klaim tidak mempengaruhi perhitungan balance
                    // if ((value.type == 'DEP' && value.claimId != null) || value.isCalculated == 0 || description.includes('Penarikan')) {

                    // } else {
                    //     let subBalance = (debitAmount - creditAmount)
                    //     countBalance = (countBalance + subBalance)
                    // }

                    let arrayDescriptionContainer = '';
                    let arrayClaimDetail = '';
                    let arrayClaimGroupDetail = [];
                    let isCategory = ''; // pay or disc

                    if (value.payment != null) {
                        if (value.payment.payment_allocate != null) {
                            arrayDescriptionContainer = value.payment.payment_allocate
                        }

                        if (value.payment.claim != null) {
                            arrayClaimDetail = value.payment.claim.claim_detail

                            if (value.payment.claim_group != null) {
                                arrayClaimGroupDetail = value.payment.claim_group.claim_group_detail
                            }
                        }
                        isCategory = value.payment.category
                    } else if (value.claimId != null) {

                        arrayClaimDetail = value.claim.claim_detail
                        isCategory = 'disc'
                    }

                    if (isCategory == 'disc') {
                        _.forEach(arrayClaimDetail, function (claim) {
                            let categoryClaimName = claim.category_claim ? claim.category_claim.name + ' : ' : ''
                            description += '<br/> - ' + categoryClaimName + claim.description
                        })

                        _.forEach(arrayClaimGroupDetail, function (claim) {
                            let categoryClaimName = claim.category_claim ? claim.category_claim.name + ' : ' : ''
                            description += '<br/> - ' + categoryClaimName + claim.description
                        })
                    } else {
                        _.forEach(arrayDescriptionContainer, function (paymentAllocate) {
                            if (paymentAllocate.invoice_due != null) {
                                description += '<br/>- ' + paymentAllocate.invoice_due.receivable.description
                            } else {
                                description += '<br/><font style="color:red">- NOT_FOUND </font>'

                                var errorMessage = 'Transaksi tgl ' + parent.showDateFormatted(value.transactionDate) + ' ada Invoice yang berubah';

                                parent.$Notice.warning({
                                    title: "Perhatian",
                                    desc: errorMessage,
                                    duration: 0
                                });

                            }
                        })
                    }

                    let category = ''
                    let claim = ''
                    let giro = ''
                    let giroId = ''
                    let claim_group = ''

                    if (value.payment) {
                        category = value.payment.category
                        claim = value.payment.claim
                        giro = value.payment.giro
                        giroId = value.payment.giroId

                        if (value.payment.claim) {
                            if (value.payment.claim.list_claim_group) {
                                claim_group = value.payment.claim.list_claim_group.claim_group_detail
                                console.info(claim, claim_group) // ini harus didetailkan lagi karena ada claim dan claim_group nya
                            }
                        }
                    }

                    const compareDate = new Date("2025-03-01")
                    let markingHeader = value.marking_header.markingheadercode.split('/')[0]
                    let isPrefixSPecial = markingHeader == "SBR" || markingHeader == "SBRT" || markingHeader == "CTH" || value.markingHeaderId == 2741
                    let creditAmountIdr = creditAmount
                    let debitAmountIdr = debitAmount
                    let currencyRate = null;
                    let debitResult = 0;
                    let creditResult = 0;
                    let transactionDate = new Date(value.transactionDate);
                    let originalRate = value.currency_rate;

                    parent.isShowRateAdjustment = isPrefixSPecial; // show - create button rate-adjustment

                    if (value.payment != null && value.payment.amount > 0 && isPrefixSPecial) { // Jika ada payment (kredit)
                        debitAmount = 0;
                        // creditAmount = 0
                        debitAmountIdr = 0;
                        creditAmountIdr = 0;

                        value.payment.payment_allocate.forEach(paymentAllocate => {
                            let receivableId = paymentAllocate.invoice_due.receivable.id;
                            const receivable = receivableRes.data.find(receiObj => receiObj.id == receivableId);
                            debitAmount = debitAmount + parseFloat(0);
                            // creditAmount = creditAmount + parseFloat(paymentAllocate.allocateAmount);
                            if (receivable && receivable.invoice && receivable.invoice.packaging_list.container_loading.currency_sgd && transactionDate < compareDate) {
                              if(value.isConvert == 2 || transactionDate >= compareDate) {
                                currencyRate = value.currency_sgd.currencyrate;
                                if(originalRate != null && originalRate != 0){
                                  currencyRate = originalRate;
                                }
                                debitAmountIdr = debitAmountIdr + (parseFloat(0) * currencyRate);
                                creditAmountIdr = creditAmountIdr + (parseFloat(paymentAllocate.allocateAmount) * currencyRate);
                              } else {
                                currencyRate = receivable.invoice.packaging_list.container_loading.currency_sgd.currencyrate;
                                if(originalRate != null && originalRate != 0){
                                  currencyRate = originalRate;
                                }
                                debitAmountIdr = debitAmountIdr + (parseFloat(0) * currencyRate);
                                creditAmountIdr = creditAmountIdr + (parseFloat(paymentAllocate.allocateAmount) * currencyRate);
                              }

                            } else if (value && value.currency_sgd) {
                              // if(value.isConvert == 2 || receivable.invoice == null || transactionDate >= compareDate) {
                              if(value.isConvert == 2 || transactionDate >= compareDate) {
                                currencyRate = value.currency_sgd.currencyrate;
                                if(originalRate != null && originalRate != 0){
                                  currencyRate = originalRate;
                                }
                                debitAmountIdr = debitAmountIdr + (parseFloat(0) * currencyRate);
                                creditAmountIdr = creditAmountIdr + (parseFloat(paymentAllocate.allocateAmount) * currencyRate);
                              } else {
                                currencyRate = receivable.invoice.packaging_list.container_loading.currency_sgd.currencyrate;
                                if(originalRate != null && originalRate != 0){
                                  currencyRate = originalRate;
                                }
                                debitAmountIdr = debitAmountIdr + (parseFloat(0) * currencyRate);
                                creditAmountIdr = creditAmountIdr + (parseFloat(paymentAllocate.allocateAmount) * currencyRate);
                              }
                            }
                        });

                        if (value.payment.category == 'income' && value.type == 'DFM') {
                            debitAmount = numeral(value.debitAmount).format('0,0.00') + " (" + numeral(value.debitAmount * value.currency_sgd.currencyrate).format('0,0.00') + ")";
                        }


                    } else if (value.invoice != null) { // Jika ada invoice (debet)

                        if (value.invoice.packaging_list &&
                            value.invoice.packaging_list.container_loading &&
                            value.invoice.packaging_list.container_loading.currency_sgd != null) {
                            currencyRate = value.invoice.packaging_list.container_loading.currency_sgd.currencyrate;
                            if(originalRate != null && originalRate != 0){
                              currencyRate = originalRate;
                            }
                        }

                    } else if (value.currency_sgd != null) { // Jika tidak ada invoice dan payment (debet)
                        currencyRate = value.currency_sgd.currencyrate;
                        if(originalRate != null && originalRate != 0){
                          currencyRate = originalRate;
                        }
                        if (value.paymentId) {
                            const receivable = receivableRes.data.find(receiObj =>
                                receiObj.payment && receiObj.payment.id == value.paymentId
                            );
                            if (receivable && receivable.invoice && receivable.invoice.packaging_list.container_loading.currency_sgd) {
                                currencyRate = receivable.payment_allocate[0].invoice_due.receivable.currency_sgd.currencyrate
                            }
                        }
                    }

                    if (currencyRate || !isPrefixSPecial) {
                        debitResult = parent.formatAmount(debitAmount, currencyRate, value.isConvert, isPrefixSPecial);
                        creditResult = parent.formatAmount(creditAmount, currencyRate, value.isConvert, isPrefixSPecial);
                        debitAmount = debitResult.formattedAmount;
                        debitAmountIdr = debitResult.amountIdr;
                        creditAmount = creditResult.formattedAmount;
                        creditAmountIdr = creditResult.amountIdr;
                    }

                    //Faisal 12 Januari : Deposit dari Klaim tidak mempengaruhi perhitungan balance
                    // if (value.type === 'DFM' || (!value.claimId && value.isCalculated !== 0 || !description.includes('Penarikan'))) {
                    //   const subBalance = debitAmountIdr - creditAmountIdr;
                    //   // Use single Math.round for better performance
                    //   countBalance = Math.round((countBalance + subBalance) * 100) / 100;
                    // }

                    //Faisal 12 Januari : Deposit dari Klaim tidak mempengaruhi perhitungan balance
                    if ((value.type == 'DEP' && value.claimId != null && value.type != 'DFM') || (value.type == 'DFM' && value.transactionDate >= '2025-08-25' && value.debitAmount == 0 && value.payment_pending_id == null) || value.isCalculated == 0 || (description.includes('Penarikan') && value.type == 'DEP')) {

                    } else {
                        let subBalance = (debitAmountIdr - creditAmountIdr)
                        countBalance = Math.round(countBalance * 100) / 100 + Math.round(subBalance * 100) / 100;
                    }

                    // if (value.type != 'DFM') {
                    //     let subBalance = (debitAmountIdr - creditAmountIdr)
                    //     countBalance = Math.round(countBalance * 100) / 100 + Math.round(subBalance * 100) / 100;
                    // }

                    let balance = countBalance;
                    if (isPrefixSPecial) {
                        balance = numeral(countBalance).format('0,0.00')
                    } else {
                        balance = numeral(countBalance).format('0,0')
                    }

                    if (value.type == 'DFM') {
                        parent.totalMutasiRemaining = parent.totalMutasiRemaining + (parseFloat(value.creditAmount) - parseFloat(value.payment_sum));
                    }

                    // Deposit dari Pembayaran Mutasi : tidak mempengaruhi perhitungan balance (readonly/info), start from 1 Januari 2026
                    // if (value.isReadonlyAmount && value.transactionDate >= '2026-01-01') {
                    //   description += ` - Rp. (${creditAmount})`,
                    //   creditAmount = 0
                    // }

                    let createdby = "<br/><i>" + value.createdby + "</i>"
                    let receivable = {
                        receivableId: value.id,
                        transactionDate: parent.showDateFormatted(value.transactionDate) + createdby,
                        currency_rate: value.currency_rate,
                        valueTransactionDate: value.transactionDate,
                        markingHeaderId: value.markingHeaderId,
                        invoicefee: numeral(invoicefee).format('0,0'),
                        invoiceid: value.invoiceid,
                        isSettled: isSettled,
                        markingheadercode: value.marking_header.markingheadercode,
                        description: description,
                        realDescription: realDescription,
                        debitAmount: debitAmount,
                        creditAmount: creditAmount,
                        paymentSum: paymentSum,
                        balance: balance,
                        category: category,
                        type: value.type,
                        claimId: value.claimId,
                        claim: claim,
                        giroId: giroId,
                        giro: giro,
                        payment: value.payment,
                        paymentPendingId: value.payment_pending_id,
                        invoice_due: value.invoice_due,
                    }

                    receivables.push(receivable);

                    if (receivable.creditAmount != '0.00 (0.00)') {
                      const listContainer = {
                        receivableId: value.id,
                        labelContainer: value.description
                      };
                      parent.createRateAdjustment.containers.push(listContainer);
                    }
                });

                this.receivables = receivables;
                this.loadingGetReceivable = false;

                parent.depositRemaining = depositRemainingRes.data.remaining
                parent.depositMutasiRemaining = depositMutasiRes.data.remaining
                parent.countBalance = countBalance

                this.getHistoryDeleteClaim();
            }))
                .catch(e => {
                    console.info(e)
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        getMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                        // .post('marking/getByCodeAll', {
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.subbranchcode || null
                        })
                        .then(response => {

                            this.invoiceDues = []
                            this.amountResidue = ''
                            this.amountReceived = ''
                            this.description = ''

                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode,
                                    top_color: item.top_color
                                };
                            });

                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.loadingGetMarking = false;
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        isSettled: function (invoice) {
            if (invoice != null) {
                if (invoice.settledDate != null) {
                    return true;
                }
            }

            return false;
        },
        handleKreditClick: function (row) {
            this.modal.createPayment = true

            this.createPaymentPending.paymentDate = moment(Date.now()).locale('id').format('yyyy-MM-DD');
            this.createPaymentPending.description = '';
            this.createPaymentPending.mutasiRemainingPayment = this.totalMutasiRemaining;
            this.createPaymentPending.paymentPendingId = row.paymentPendingId;
            this.createPaymentPending.category = "pay";
            this.createPaymentPending.receivableId = row.receivableId;
            console.info("handleKreditClick", this.createPaymentPending)
            this.invoiceDues = [];
            this.getInvoiceData()
        },
        getInvoiceDueUnSettled: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('invoiceDue/unsettled/' + this.markingIdSelected)
            } else {
                this.invoiceDues = []
            }
        },
        getInvoiceData: function () {
            this.loadingGetPayment = true;

            this.invoiceDues = []
            this.createPaymentPending.amountResidue = ''
            this.createPaymentPending.amountReceived = ''
            this.createPaymentPending.description = ''
            this.createPaymentPending.totalUseDepositAmount = 0;

            if (this.markingIdSelected == '') {
                this.loadingGetPayment = false;
                return;
            }

            let parent = this;

            axios.all([
                this.getInvoiceDueUnSettled(),
            ]).then(axios.spread((unSettledRes) => {
                let invoiceDuesFormatted = []
                _.forEach(unSettledRes.data, function (value) {

                    let receivableType = value.receivable.type;

                    let invoicefee = value.receivable.debitAmount;
                    let invoicedate = value.receivable.transactionDate;
                    let invoicedatedue = '';

                    if (receivableType != 'MAN') {
                        let invoicefee = value.receivable.invoice.invoicefee;
                        let invoicedatedue = value.receivable.invoice.invoicedatedue;
                        let invoicedate = value.receivable.invoice.invoicedate;
                    }

                    let paymentSum = value.paymentSum;
                    let receivableRemaining = invoicefee - paymentSum;
                    let receivableDebitAmount = value.receivable.debitAmount;

                    let payment = {
                        id: value.id,
                        receivableId: value.receivableId,
                        invoicefee: invoicefee, // total invoice
                        paymentSum: paymentSum, // total pembayaran yang sudah dilakukan
                        receivableRemaining: receivableRemaining, // sisa piutang
                        description: value.receivable.description,
                        invoicedate: invoicedate, //numeral(value.receivable.creditAmount).format('0,0')
                        invoicedatedue: invoicedatedue,
                        receivableDebitAmount: receivableDebitAmount, // menyimpan nilai awal
                        allocateAmount: 0,
                        deviationAmount: 0, // untuk menyimpan kelebihan bayar
                        useDepositAmount: 0, // nilai penggunaan deposit (jika ada deposit)
                        markingHeaderId: value.receivable.markingHeaderId,
                        pendingAmount: 0,
                        discountAmount: 0
                    }

                    invoiceDuesFormatted.push(payment);
                });

                if (invoiceDuesFormatted.length > 0) {
                    invoiceDuesFormatted = _.sortBy(invoiceDuesFormatted, ['invoicedate'], function (value) { return new Date(value); });

                    let pendingAmount = this.createPaymentPending.paymentPendingAmount;
                    let index = 0;

                    if (pendingAmount && pendingAmount > 0) {
                        _.forEach(invoiceDuesFormatted, function (value) {
                            if (pendingAmount && pendingAmount > 0 && pendingAmount > value.receivableRemaining) {
                                invoiceDuesFormatted[index].pendingAmount = value.receivableRemaining;
                                pendingAmount = pendingAmount - value.receivableRemaining;
                            } else if (pendingAmount && pendingAmount > 0 && pendingAmount <= value.receivableRemaining) {
                                invoiceDuesFormatted[index].pendingAmount = pendingAmount;
                                pendingAmount = 0;
                            }

                            index++;
                        });
                    }

                    parent.invoiceDues = invoiceDuesFormatted;
                } else {
                    if (this.markingIdSelected) {
                        this.$Message.info('Piutang tidak ditemukan');
                    }
                }
                parent.loadingGetPayment = false;
            }))
                .catch(e => {
                    console.log(e)
                    this.loadingGetPayment = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: 'Silahkan Cek Menu Piutang > Hapus Piutang',
                        duration: 0
                    });
                });
        },
        setAllocateAmount: function (invoiceDue) {
            const isDeviation = invoiceDue.allocateAmount + invoiceDue.useDepositAmount > invoiceDue.receivableRemaining
            if (isDeviation) {
                invoiceDue.deviationAmount = (invoiceDue.allocateAmount + invoiceDue.useDepositAmount) - invoiceDue.receivableRemaining;
            } else {
                invoiceDue.deviationAmount = 0
            }

            var index = _.findIndex(this.invoiceDues, { id: invoiceDue.id });

            // Replace item at index using native splice
            this.invoiceDues.splice(index, 1, invoiceDue);

            // var invoiceDueChanged = _.find(this.invoiceDues, {id: invoiceDue.id});
            this.setResidueAmount(true);
            this.checkButtonSave();
        },
        setMarkingCode: function () {
            // this.markingIdSelected = ''

            const selectedOption = this.optionMarkings.find(
              item => item.value === this.markingIdSelected
            );

            if (selectedOption) {
              this.markingLabelSelected = selectedOption.label;
              this.topColor = selectedOption.top_color;
            } else {
              this.markingLabelSelected = "";
              this.topColor = "";
            }

            this.getReceivableData()
            this.createPaymentPending.selectedMarkingLabel =
                this.optionMarkings.find(item => item.value == this.markingIdSelected) ?
                    this.optionMarkings.find(item => item.value == this.markingIdSelected).label : '';
        },
        setResidueAmount: function (fromChild) {
            let allocateAmounts = _.sumBy(this.invoiceDues, 'allocateAmount');
            let allocateDiscountAmounts = _.sumBy(this.invoiceDues, 'discountAmount');
            this.createPaymentPending.amountResidue = this.createPaymentPending.amountReceived - allocateAmounts;

            if (fromChild) {
                console.info('from child')
                this.createPaymentPending.amountReceived = allocateAmounts;
                this.createPaymentPending.totalUseDepositAmount = _.sumBy(this.invoiceDues, 'useDepositAmount');

                this.createPaymentPending.discountReceived = allocateDiscountAmounts;
            }

            let sumDeviation = _.sumBy(this.invoiceDues, 'deviationAmount');
            this.createPaymentPending.depositAmount = sumDeviation
        },
        postPayment: function () {

            if (this.createPaymentPending.depositAmount > 0 && this.createPaymentPending.depositType == '') {
                this.modal.createPayment = true;
                return;
            } else {
                this.modal.createPayment = false;
            }

            this.loadingPost = true
            let paymentAllocates = [];

            _.forEach(this.invoiceDues, function (invoiceDue) {
                if (invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                    invoiceDue.invoicefee == 0) {
                    let paymentAllocate = {
                        invoicefee: invoiceDue.invoicefee, // total invoice awal
                        invoiceDueId: invoiceDue.id,
                        allocateAmount: invoiceDue.allocateAmount, // allocate amount yang dibayar
                        receivableRemaining: invoiceDue.receivableRemaining, // sisa piutang yang bisa dibayar
                        useDepositAmount: invoiceDue.useDepositAmount,
                        description: invoiceDue.description,
                    }
                    paymentAllocates.push(paymentAllocate);
                }

            });

            this.createPaymentPending.paymentAllocates = paymentAllocates;
            let transactionDate = moment(this.createPaymentPending.paymentDate, "DD/MM/YYYY").format('YYYY/MM/DD')

            let payload = {
                receivableId: this.createPaymentPending.receivableId,
                markingHeaderId: this.markingIdSelected,
                amount: this.createPaymentPending.amountReceived,
                transactionDate: transactionDate,
                description: this.createPaymentPending.description,
                accountNumber: this.createPaymentPending.accountNumber,
                depositAmount: this.createPaymentPending.depositAmount,
                paymentAllocates: this.createPaymentPending.paymentAllocates,
                depositType: this.createPaymentPending.depositType,
                category: this.createPaymentPending.category,
                paymentPendingId: this.createPaymentPending.paymentPendingId,
                creditRound: this.createPaymentPending.creditRound,
                coaId: this.createPaymentPending.creditRound > 0 ? this.createPaymentPending.coaId : null
            }

            // console.log({ payload });
            // return false

            HTTP
                .post('payment/payPending', payload)
                .then(response => {
                    this.loadingPost = false

                    this.$Message.success({
                        content: 'Pembayaran Berhasil',
                        duration: 5
                    });

                    this.getReceivableData()
                })
                .catch(e => {
                    this.loadingPost = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                    console.error(e)
                })
        },
        postCreateRateAdjustment: function () {
            this.loadingCreateRateAdjustment = true;

            const selectedContainer = this.createRateAdjustment.containers.find(
                c => c.receivableId === this.createRateAdjustment.containerSelected
            );

            let payload = {
                markingHeaderId: this.markingIdSelected,
                receivableId: this.createRateAdjustment.containerSelected,
                transactionDate: moment(this.createRateAdjustment.transactionDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                description: "Penyesuaian Rate - " + (selectedContainer ? selectedContainer.labelContainer : ''),
                amount: this.createRateAdjustment.amount
            }

            console.log({ payload });

            // return false;

            HTTP
                .post('receivable/rate-adjustment/create', payload)
                .then(response => {
                    this.clearCreateRateAdjustment()

                    this.loadingCreateRateAdjustment = false
                    this.modal.createRateAdjustment = false

                    this.$Message.success({
                        content: 'Penyesuaian Rate Berhasil',
                        duration: 5
                    });

                    this.getReceivableData()
                })
                .catch(e => {
                    this.clearCreateRateAdjustment()
                    this.loadingCreateRateAdjustment = false
                    this.modal.createRateAdjustment = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        submitRate() {
            let payload = {
                receivableId: this.formRate.receivable_id,
                rate: this.formRate.rate,
            }

            if(this.user.role === 'ADMINISTRATOR') {
                payload.settleDate = this.formRate.settleDate;
                payload.paymentSum = this.formRate.paymentSum;
            }

            this.showModal = false

            HTTP
                .post('receivable/rate', payload)
                .then(response => {
                    this.getReceivableData()
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        confirmDelete(row) {
          this.$Modal.confirm({
            title: 'Confirmation',
            width: '25%',
            content: 'Are you sure you want to delete this receivable ?',
            onOk: () => {

              this.deleteReceivable(row);
            },
          })
        },
        submitEditReceivable() {
            let payload = {
                receivableId: this.formRate.receivable_id,
                description: this.formRate.realDescription
            }

            if(this.user.role === 'ADMINISTRATOR') {
                payload.settleDate = this.formRate.settle_date;
                payload.paymentSum = this.formRate.payment_sum;
            }

            this.showModalDesc = false

            HTTP
                .post('receivable/edit', payload)
                .then(response => {
                    this.getReceivableData()
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getHistoryEditDescription() {
            HTTP
                .post('receivable/edit/history', {
                    receivableId: this.formRate.receivable_id,
                    type: 'receivable',
                    action: 'edit'
                })
                .then(response => {
                    this.historyData = response.data.data;
                    this.showModalDesc = true;

                    this.$Loading.finish();
                })
                .catch(e => {
                    this.$Loading.finish();
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        setSettlementStatusToPaymentAllocate(data) {
          HTTP
              .post('receivable/settlement', {
                  payment_allocate_id : data.id,
                  status: data.checked
              })
              .then(response => {
                  this.$Notice.success({
                    title: 'Success',
                    desc: 'Payment settlement has been updated successfully.',
                    duration: 4
                  })

                  this.getReceivableData();
                  this.$Loading.finish();
              })
              .catch(e => {
                  this.$Loading.finish();
                  this.$Notice.error({
                    title: 'Error',
                    desc: e.message || 'Failed to update payment settlement.',
                    duration: 5
                  })
              })
        },
        deleteReceivable(id) {

          HTTP
              .post('receivable/delete', {
                  receivableId : id,
                  type: 'receivable'
              })
              .then(response => {
                  this.$Notice.success({
                    title: 'Success',
                    desc: 'Payment settlement has been updated successfully.',
                    duration: 4
                  })

                  this.showModal = false;
                  this.getReceivableData();
                  this.$Loading.finish();
              })
              .catch(e => {
                  this.showModal = false;
                  this.$Loading.finish();
                  this.$Notice.error({
                    title: 'Error',
                    desc: e.message || 'Failed to update payment settlement.',
                    duration: 5
                  })
              })
        },
        checkButtonSave: function () {
            let paymentDate = this.createPaymentPending.paymentDate
            let description = this.createPaymentPending.description
            let amountReceived = this.createPaymentPending.amountReceived
            let mutasiRemainingPayment = this.createPaymentPending.mutasiRemainingPayment

            this.isButtonSave = false
            if (paymentDate && description && amountReceived > 0 && amountReceived <= mutasiRemainingPayment) {
                this.isButtonSave = true
            } else {
                this.isButtonSave = false
            }

            this.invoiceDues.map((invoiceDue) => {
                if (invoiceDue.deviationAmount > 0) {
                    this.isButtonSave = false
                }
            })
        },
        formatAmount: function (amount, currencyRate, isConvert, isPrefixSpecial) {
            let amountIdr = amount;
            let formattedAmount = "";

            if (currencyRate != null && isConvert) {
                amountIdr = Number(amount).toFixed(2) * currencyRate;
                formattedAmount = numeral(amount).format('0,0.00') + " (" + numeral(amountIdr).format('0,0.00') + ")";
            } else if (isPrefixSpecial) {
                formattedAmount = numeral(amount).format('0,0.00');
            } else {
                formattedAmount = numeral(amount).format('0,0');
            }

            return {
                formattedAmount,
                amountIdr
            };
        },
        getHistoryDeleteClaim() {
            HTTP
                .post('history/delete-klaim', {
                    markingHeaderId: this.markingIdSelected
                })
                .then(response => {
                let parent = this;
                let historyData = []

                _.forEach(response.data, function(value) {
                      let payment = {
                          paymentDate : parent.showDateFormatted(value.paymentDate),
                          markingheadercode : value.marking_header.markingheadercode,
                          description : value.receivable.description,
                          transactionNote : value.pending != null ? value.pending.noteCode : '-',
                          amount : numeral(value.amount).format('0,0'),
                          deleteAt : value.created_at,
                          deletedBy : value.deletedBy,
                      }

                      historyData.push(payment);
                  });

                  this.historyDeleteClaim = historyData;
                  this.activeCollapseNames = [];
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        }
    },
    watch: {
        "createPaymentPending.amountReceived": function (newAmountReceived) {
            this.setResidueAmount(false)
        }
    },
    created() {
        this.user.username = localStorage.getItem('user.username')
        this.user.role = localStorage.getItem('user.role')

        this.createReceivable = {
            transactionDate: null,
            description: '',
            amount: 0,
            filename: '',
            imageUploaded: '',
        };
    },
    computed: {
      alertType() {
        switch (this.topColor) {
          case 'GREEN': return 'success'
          case 'YELLOW': return 'warning'
          case 'RED': return 'error'
          default: return 'info'
        }
      },
      alertClass() {
        switch (this.topColor) {
          case 'GREEN': return 'alert-green'
          case 'YELLOW': return 'alert-yellow'
          case 'RED': return 'alert-red'
          default: return ''
        }
      }
    },
    mounted() {
        this.$Loading.config({
            color: '#ffffff',
            failedColor: '#f0ad4e',
            height: 15
        });
    }
}
</script>

<style scoped>
.alert-green {
  background-color: #008000 !important; /* hijau muda */
  border-color: #ffffff !important;
  color: #000000 !important;
}
.alert-yellow {
  background-color: #FFFF00 !important; /* kuning muda */
  border-color: #ffffff !important;
  color: #000000 !important;
}
.alert-red {
  background-color: #ff1100 !important; /* merah muda */
  border-color: #ffffff !important;
  color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// ReceivableCutOffList.vue?da1234de